import { ADDOFFERS } from "../../utils/api";
import axios from "../../utils/axios";

export const AddOffersApi = async (params) => {
  const res = await axios.post(ADDOFFERS, params);
  return res;
};
